import axiosClient from "./axiosClient";
import { apiEndpoints, secureBusinessKey } from "./apiEndpoints";
import Cookies from "js-cookie";

export const updateEcommerceID = (ecomm_order_id, reservation_id) => {
  const personal_token = Cookies.get("personal_token");
  if (!personal_token) {
    window.location.href = "/logout"; // Redirect if branchId is missing
    return Promise.reject(
      new Error("Personal Token is missing. Redirecting to logout.")
    );
  }
  return axiosClient.post(
    apiEndpoints.updateEcommID.url(reservation_id),
    { ecomm_order_id: ecomm_order_id },
    {
      headers: {
        "secure-business-key": secureBusinessKey,
        "Content-Type": "application/json",
        "user-token": personal_token,
      },
    }
  );
};
